import qs from 'query-string';

import { Methods, PayEntitiesEnum } from '~/api/finance/financeApiTypes';
import { HttpProblemError } from '~/api/provider/providerErrors';
import { buyAbonnementActions } from '~/feature/book/buyAbonnement/buyAbonnement.slice';
import { paymentTransaction } from '~/feature/book/paymentResult/paymentResult.data';
import { paymentResultActions } from '~/feature/book/paymentResult/paymentResult.slice';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { me } from '~/feature/user/user.data';
import { userSelector } from '~/feature/user/user.selector';
import { BuyAbonnementProps, financeGraphql } from '~/graphql/finance/financeGraphql';
import { createAppThunk } from '~/store';

export const buyAbonnement = createAppThunk<
void,
Pick<BuyAbonnementProps, 'abonnementType' | 'bookId'>
>(
  '/buyAbonnement',
  async (data, thunkAPI) => {
    try {
      const { user: { email: userEmail, phone } } = userSelector(thunkAPI.getState());
      const { activeMethod, receiptContact } = choosePaySelector(thunkAPI.getState());
      const bankCardId = 'card' in activeMethod ? activeMethod.card?.id : undefined;
      const needsContact = !userEmail && !phone;
      const email = needsContact && receiptContact.includes('@') ? receiptContact : undefined;
      const cleanedPhone = needsContact && receiptContact && !receiptContact.includes('@')
        ? receiptContact.replace(/\D/g, '')
        : undefined;
      const paymentMethod = activeMethod.type as Methods.bankCard | Methods.savedBankCard;

      const currentUrl = qs.parseUrl(window?.location?.href);
      const returnUrl = qs.parseUrl(currentUrl.url);

      returnUrl.query.payEntity = PayEntitiesEnum.Abonnement;
      returnUrl.query.methodPayment = paymentMethod;
      returnUrl.query.transactionId = 'TIDSET';

      const result = await financeGraphql.buyAbonnement({
        ...data,
        paymentMethod,
        returnUrl: qs.stringifyUrl(returnUrl),
        emailForReceipt: email,
        phone: cleanedPhone,
        bankCardId,
      });

      await thunkAPI.dispatch(paymentTransaction({
        transactionId: result?.transaction.id,
        confirmationUrl: result?.transaction.confirmationUrl,
        methodPayment: paymentMethod,
        payEntity: PayEntitiesEnum.Abonnement,
        successTransactionHandler: async () => {
          await thunkAPI.dispatch(me());
          await thunkAPI.dispatch(buyAbonnementActions.setIsOpenChoosePayModal(false));
          await thunkAPI.dispatch(paymentResultActions.openModal('buyAbonnementSuccess'));
        },
        failedTransactionHandler: async () => {
          await thunkAPI.dispatch(buyAbonnementActions.setIsOpenChoosePayModal(false));
          await thunkAPI.dispatch(paymentResultActions.openModal('buyAbonnementReject'));
        },
      }));
    } catch (error) {
      if (error instanceof HttpProblemError) {
        const { message } = await import('~/atomic/atom/message');
        message.error(error.message);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);
